export default __webpack_public_path__ + "static/media/Calculator of CPD Points.8c12c74b.xls";